import clsx from 'clsx'
import React, { ReactElement } from 'react'
import { Controller } from 'react-hook-form'
import { useIntl } from 'react-intl'

import styles from './styles.module.scss'

export interface IControllerSwitchFieldProps {
  control: any
  rules?: any
  name: any
  message?: string
  label?: string | ReactElement
  placeholder?: string
  ref?: any
  inline?: boolean
  active?: any
  inactive?: any
  defaultValue?: any
  disabled?: boolean
}

export default function ControlledSwitchField({
  control,
  rules,
  name,
  message,
  label,
  ref,
  inline = false,
  active = true,
  inactive = false,
  defaultValue = false,
  disabled = false,
}: IControllerSwitchFieldProps) {
  const intl = useIntl()
  return (
    <div className={`${styles.field} ${inline ? styles.inline : ''}`}>
      <div className={styles.title}>{label}</div>
      <Controller
        control={control}
        rules={rules}
        name={name}
        render={({ field, formState: { errors } }) => (
          <>
            <div
              className={clsx(
                styles.switch,
                {
                  [styles.checked]:
                    field.value === active ||
                    (field.value === undefined && defaultValue === active),
                },
                { [styles.disable]: disabled },
              )}
              onClick={() =>
                !disabled &&
                field.onChange(
                  field.value === active ||
                    (field.value === undefined && defaultValue === active)
                    ? inactive
                    : active,
                )
              }
              ref={ref}
            >
              <div className={styles.container}>
                {field.value === active ||
                (field.value === undefined && defaultValue === active)
                  ? intl.formatMessage({
                      defaultMessage: 'Oui',
                      id: 'ui.ControlledSwitchField.yes',
                    })
                  : intl.formatMessage({
                      defaultMessage: 'Non',
                      id: 'ui.ControlledSwitchField.no',
                    })}
              </div>
              <div className={styles.button}></div>
            </div>
            {errors[name] && (
              <span className='form__error'>
                {errors[name]?.message?.toString() || 'Erreur'}
              </span>
            )}
          </>
        )}
      />

      {message && <span color='red'>{message}</span>}
    </div>
  )
}
